import * as React from 'react';
import './serviceAgreementPane.module.scss';
import { observer } from 'mobx-react';
import { CheckBox } from '@sheinc/design-system';
import { TermsOfServicePane } from './TermsOfServicePane';
import { CheckPointsPane } from './CheckPointsPane';
import { ServiceAgreementState } from '../../../states/ServiceAgreementState';

type Props = {
  paneState: ServiceAgreementState;
};

export const ServiceAgreementPane = observer(
  ({ paneState: { serviceAgreement, cardsChecked, lastChecked, setCardChecked, setLastChecked } }: Props) => {
    const { content, check_points } = serviceAgreement;
    return (
      <div styleName="service-agreement-wrapper">
        <TermsOfServicePane content={content} />
        {check_points.length !== 0 && (
          <CheckPointsPane serviceAgreement={serviceAgreement} cardsChecked={cardsChecked} onCheck={setCardChecked} />
        )}
        <div styleName="check-confirm">
          <CheckBox id="check-confirm" onCheck={setLastChecked} checked={lastChecked}>
            {check_points.length === 0 ? (
              <div>利用規約についてよく理解し、同意する</div>
            ) : (
              <div>利用規約の全文と上記{check_points.length}項目についてよく理解し、同意する</div>
            )}
          </CheckBox>
        </div>
      </div>
    );
  }
);
